import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import TableHeadRow from './TableHeadRow';

var TableHead = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TableHead, _React$PureComponent);

  var _super = _createSuper(TableHead);

  function TableHead() {
    _classCallCheck(this, TableHead);

    return _super.apply(this, arguments);
  }

  _createClass(TableHead, [{
    key: "getHeadRows",

    /**
     * 拆分columns，并且设置rowSpan/colSpan 实现表头分组
     */
    value: function getHeadRows(columns) {
      var _this = this;

      var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var parentCell = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      rows[currentRow] = rows[currentRow] || [];

      var setRowSpan = function setRowSpan(cell) {
        var rowSpan = rows.length - currentRow;

        if (cell && !cell.isGroup && rowSpan > 1 && (!cell.rowSpan || cell.rowSpan < rowSpan)) {
          cell.rowSpan = rowSpan;
        }
      };

      columns.forEach(function (c, index) {
        var cell = {
          key: c.prop,
          data: c,
          index: index
        };
        parentCell.colSpan = parentCell.colSpan || 0;

        if (c.children) {
          cell.key = cell.key || "th_group_".concat(currentRow, "_").concat(index);
          cell.isGroup = true;

          _this.getHeadRows(c.children, currentRow + 1, cell, rows);

          parentCell.colSpan += cell.colSpan;
        } else {
          parentCell.colSpan += 1;
        }

        rows[currentRow].push(cell);
      });
      rows[currentRow].forEach(setRowSpan);
      return rows.filter(function (r) {
        return r.length;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columns = _this$props.columns,
          onSort = _this$props.onSort,
          sort = _this$props.sort,
          heightMap = _this$props.heightMap,
          onSyncHeight = _this$props.onSyncHeight;
      var rows = this.getHeadRows(columns);
      return /*#__PURE__*/React.createElement("thead", null, rows.map(function (row, index) {
        return /*#__PURE__*/React.createElement(TableHeadRow, {
          key: "row".concat(index),
          row: row,
          indexKey: "tableHead_".concat(index),
          onSort: onSort,
          sort: sort,
          height: heightMap && heightMap["tableHead_".concat(index)],
          onSyncHeight: onSyncHeight
        });
      }));
    }
  }]);

  return TableHead;
}(React.PureComponent);

export { TableHead as default };